import { render, staticRenderFns } from "./EstateAgentContactNumber.vue?vue&type=template&id=247e2339"
import script from "./EstateAgentContactNumber.vue?vue&type=script&lang=js"
export * from "./EstateAgentContactNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports